/* eslint-disable */
export default {
  noActiveCalls: 'Nenhuma chamada ativa',
  currentCall: 'Chamada atual',
  ringCall: 'Chamada sonora',
  onHoldCall: 'Chamada em espera',
  otherDeviceCall: 'Chamadas em andamento nos meus outros dispositivos',
  confirmation: 'Confirmação',
  confirmMergeToConference: 'Adicionar à chamada em conferência?',
  mergeToConference: 'Mesclar',
  conferenceCall: 'Chamada em conferência',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"ringCall"@#@ @source: @#@"Ringing Call"@#@
// @key: @#@"onHoldCall"@#@ @source: @#@"Call on Hold"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"Ongoing calls on my other devices"@#@
// @key: @#@"confirmation"@#@ @source: @#@"Confirmation"@#@
// @key: @#@"confirmMergeToConference"@#@ @source: @#@"Add to conference call?"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
